import { render, staticRenderFns } from "./CustomerManageDetail.vue?vue&type=template&id=6b803a32&scoped=true"
import script from "./CustomerManageDetail.vue?vue&type=script&lang=js"
export * from "./CustomerManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b803a32",
  null
  
)

export default component.exports